<template>
  <b-modal
    centered
    hide-footer
    :visible="true"
    title="Follow-up Practice Coming Soon!"
    @close="$emit('close')"
    @hide="$emit('close')"
  >
    <div class="text-center">
      <img
        src="@/assets/images/elements/waiting.png"
        alt="Waiting"
        class="mb-2"
        style="max-width: 200px;"
      >

      <h4 class="mb-3">
        Don't worry! We're preparing something special for you!
      </h4>

      <p class="mb-2">
        We noticed you had some trouble with this problem, but that's okay!
        Learning takes time and practice.
      </p>

      <p class="mb-2">
        Our system is creating new practice problems just for you to help you understand better.
        These will be ready for you very soon!
      </p>

      <p class="font-weight-bold">
        Keep going - you're doing great! 🌟
      </p>

      <b-button
        variant="primary"
        class="mt-2"
        @click="$emit('close')"
      >
        Got it!
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'InformAutoMgp',
  components: {
    BModal,
    BButton,
  },
}
</script>

  <style scoped>
  .modal-title {
    color: #2c3e50;
    font-weight: bold;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.5;
    color: #34495e;
  }
  </style>
